<template>
   <div>
        <!-- 题列表 -->
        <div shadow="hover" class="listItem xy-between" v-for="(info,i) in list" :key="i">
          <div class="left jf">
            <div class="order c-256CF4 font-size30">
              {{i+1}}
            </div>
            <div class="throw "></div>
            <div class="info ">
              <div class="className font-size18 c-333">
                {{info.SubjectName ? info.SubjectName : info.ViewName}}
              </div>
              <div class="topicType font-size14 c-72777">
                <span>分类：{{info.ClassName}}</span>
                <span class="left">题型：
                  {{info.SubjectType === "1" ?  "单选题" : info.SubjectType === "2" ? "多选题" : info.SubjectType === "3" ?
            "填空题" : info.SubjectType === "4" ? "判断题" : info.SubjectType === "5" ? "问答题" :info.SubjectType === "6" ?  "复合题" : "未知"}}</span>
                <span class="left">更新时间：{{info.SubjectTime}}</span>
              </div>
            </div>
          </div>
          <div class="right jf">
            <div class="btn collect xy-center cursor">
              <!-- <i class="el-icon-delete"></i> -->
              收藏
            </div>
            <div class="btn makeTopic xy-center cursor">
              开始做题
            </div>
          </div>
        </div>

        <!-- 卷列表 -->
      </div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            currentSatus: "topic",
            searchKey: ""
        }
    }
}
</script>

<style scoped lang="less">
   .listItem {
        width: 100%;
        height: 124px;
        background: #FFFFFF;
        margin-top: 1px;
        padding: 30px 40px;
        box-sizing: border-box;

        .left {
          .throw {
            width: 1px;
            height: 50px;
            background: #E5E8EC;
            margin: 0 40px;
          }
        }

        .info {
          height: 65px;

          .className {
            margin-bottom: 20px;
          }

          .topicType {
            .left {
              margin-left: 60px;
            }
          }
        }

        .right {
          .btn {
            width: 98px;
            height: 36px;
            background: #EBF2FF;
            border-radius: 18px;
            color: white;
          }

          .collect {
            color: #256CF4;
            margin-right: 10px;
          }

          .makeTopic {
            background: linear-gradient(270deg, #4987FF 0%, #4CA5FA 100%);
          }
        }
      }
</style>
